export const LOADING_RECIDIVISM_ACTIONS = "LOADING_RECIDIVISM_ACTIONS";
export const GET_RECIDIVISM_ACTIONS = "GET_RECIDIVISM_ACTIONS";
export const GET_RECIDIVISM_ACTIONS_DISCIPLINARIAS = "GET_RECIDIVISM_ACTIONS_DISCIPLINARIAS";
export const RECIDIVISM_ACTIONS_FAIL = "RECIDIVISM_ACTIONS_FAIL";